import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 12a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M2 12.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-1"}],["path",{"d":"M17 12.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-2"}]]

const IconBrandNextcloud = createReactComponent('outline', 'brand-nextcloud', 'BrandNextcloud', __iconNode);

export default IconBrandNextcloud;